import { useAuth } from '@/hooks/use-auth';

// True only for authenticated internal staff. The auth context user is loosely typed, so we
// narrow the super-admin flag explicitly.
export function useIsSuperAdmin(): boolean {
  const { user } = useAuth();
  return user?.isSuperAdmin === true;
}
